import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { PATHS } from "constants/pathConstants";
import { selectUserPersonalInformation } from "store/reducers/user/UserAccountSlice";
import { updateEmail } from "apis/authApi";
import PageTitle from "utils/PageTitle";
import Layout from "components/layout/Layout";
import AccountManagementMemberInfoPageStyles from "./AccountManagementMemberInfoPage.styles";
import BackTo from "components/sharedComponents/BackTo";
import ProfileForm from "components/v3/forms/ProfileForm";

const AccountManagementMemberInfoPage = (props) => {
  const history = useHistory();
  const classes = AccountManagementMemberInfoPageStyles();
  const memberInformation = useSelector(selectUserPersonalInformation);

  PageTitle("Member Information");
  const handleSubmitted = (formFields) => {
    const updatedEmail = formFields?.email || "";
    const changedContactEmail = memberInformation.email !== updatedEmail;

    if (changedContactEmail) {
      //updateEmail(formFields.email);
    }

    history.push(PATHS.ACCOUNT_MANAGEMENT);
  };

  return (
    <Layout headerType="primary">
      <Grid container justifyContent="center" alignItems="flex-start">
        <Grid item xs={12} sm={10} md={8}>
          <Grid
            container
            item
            xs={12}
            justifyContent="flex-start"
            alignItems="center"
          >
            <div className={classes.backToContainer}>
              <BackTo
                text="Account Management"
                backTo={PATHS.ACCOUNT_MANAGEMENT}
              />
            </div>
          </Grid>
          <ProfileForm onSubmitted={handleSubmitted} />
        </Grid>
      </Grid>
    </Layout>
  );
};

export default AccountManagementMemberInfoPage;
